import { useQuery } from "@tanstack/react-query";
import { documentsApi } from "../../api/documentsApi";
export var DOCUMENT_QUERY_KEY = "admin-document";
export var useDocument = function (id) {
    return useQuery({
        queryKey: [DOCUMENT_QUERY_KEY, id],
        queryFn: function () { return documentsApi.get(id); },
        enabled: !!id,
        retry: function (failureCount, error) { var _a; return ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 404 ? false : failureCount < 2; },
    });
};
